import request from '@/utils/request'

const processApi = {
  nextStepHandler: '/process/nextStepHandler', // 帮扶查下一步处理人
  launchTask: '/process/launchTask', // 发起流程
  saveProcessDraft: '/process/saveProcessDraft', // 保存流程
  saveReturnDraft: '/process/saveReturnDraft', // 最新保存流程
  getTaskBusinessData: '/process/getTaskBusinessData', // 获取流程业务数据
  dispatchTask: '/process/dispatchTask', // 处理流程
  needHelpPerson: '/auth/online/needHelpPerson', // 查询帮扶对象
  getLeader: '/auth/online/user', // 查询用户
  uploadProcessFile: '/process/uploadProcessFile', // 上传流程文件
  uploadProcessProjectFund: '/process/uploadProcessProjectFund', // 上传流程文件
  delProcessFile: 'process/delProcessFile', // 删除流程文件
  downloadProcessFile: 'process/downloadProcessFile', // 删除流程文件
  getTaskForProjectConfirmation: '/process/getTaskForProjectConfirmation', // 获取帮扶对象项目关联
  getTaskForUnProjectConfirmation: '/process/getTaskForProjectConfirmation', // 获取当前帮扶对象任务
  getProjectStatistical: '/auth/online/getProjectStatistical', // 项目数据概览
  getHistogramStatistical: '/auth/online/getHistogramStatistical', // 柱状图
  getPieChartStatistical: '/auth/online/getPieChartStatistical', // 饼图
  fundingApproval: '/process/fundingApproval' // 资金审批
}

export function nextStepHandler(parameter) {
  return request({
    url: processApi.nextStepHandler,
    method: 'post',
    data: parameter
  })
}
export function launchTask(parameter) {
  return request({
    url: processApi.launchTask,
    method: 'post',
    data: parameter
  })
}
export function saveProcessDraft(parameter) {
  return request({
    url: processApi.saveProcessDraft,
    method: 'post',
    data: parameter
  })
}
export function saveReturnDraft(parameter) {
  return request({
    url: processApi.saveReturnDraft,
    method: 'post',
    data: parameter
  })
}
export function getTaskBusinessData(parameter) {
  return request({
    url: processApi.getTaskBusinessData,
    method: 'post',
    data: parameter
  })
}

export function dispatchTask(parameter) {
  return request({
    url: processApi.dispatchTask,
    method: 'post',
    data: parameter
  })
}

export function needHelpPerson(parameter) {
  return request({
    url: processApi.needHelpPerson,
    method: 'post',
    data: parameter
  })
}

export function getLeader(parameter) {
  return request({
    url: processApi.getLeader,
    method: 'post',
    data: parameter
  })
}

export function getTaskForProjectConfirmation(parameter) {
  return request({
    url: processApi.getTaskForProjectConfirmation,
    method: 'post',
    data: parameter
  })
}

export function getTaskForUnProjectConfirmation(parameter) {
  return request({
    url: processApi.getTaskForUnProjectConfirmation,
    method: 'post',
    data: parameter
  })
}

export function uploadProcessFile(parameter) {
  // 上传流程文件
  return request({
    url: processApi.uploadProcessFile,
    method: 'post',
    data: parameter
  })
}

export function uploadProcessProjectFund(parameter) {
  // 上传流程文件
  return request({
    url: processApi.uploadProcessProjectFund,
    method: 'post',
    data: parameter
  })
}

export function delProcessFile(parameter) {
  // 删除流程文件
  return request({
    url: processApi.delProcessFile,
    method: 'post',
    data: parameter
  })
}

export function downloadProcessFile(parameter) {
  // 删除流程文件
  return request({
    url: processApi.downloadProcessFile,
    method: 'get',
    params: parameter
  })
}

export function getProjectStatistical(parameter) {
  // 删除流程文件
  return request({
    url: processApi.getProjectStatistical,
    method: 'post',
    data: parameter
  })
}

export function fundingApproval(parameter) {
  // 删除流程文件
  return request({
    url: processApi.fundingApproval,
    method: 'post',
    data: parameter
  })
}

export function getHistogramStatistical(parameter) {
  // 柱状图
  return request({
    url: processApi.getHistogramStatistical,
    method: 'post',
    data: parameter
  })
}

export function getPieChartStatistical(parameter) {
  // 饼图
  return request({
    url: processApi.getPieChartStatistical,
    method: 'post',
    data: parameter
  })
}
